import imageCompression from 'browser-image-compression'

const SIZE_THRESHOLD_BYTES = 500 * 1024
const COMPRESSION_CONCURRENCY = 4

const COMPRESSION_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  initialQuality: 0.8,
  useWebWorker: true,
}

function shouldSkip(file: File): boolean {
  if (!file.type.startsWith('image/')) return true
  if (file.type === 'image/gif') return true
  if (file.size <= SIZE_THRESHOLD_BYTES) return true
  return false
}

export async function compressImage(file: File): Promise<File> {
  if (shouldSkip(file)) return file
  try {
    const compressed = await imageCompression(file, COMPRESSION_OPTIONS)
    return compressed.size < file.size
      ? new File([compressed], file.name, {
          type: compressed.type || file.type,
          lastModified: file.lastModified,
        })
      : file
  } catch (err) {
    console.warn('Image compression failed; uploading original.', err)
    return file
  }
}

export async function compressImages(
  files: File[],
  onProgress?: (done: number, total: number) => void
): Promise<File[]> {
  const total = files.length
  const results: File[] = new Array(total)
  let done = 0
  let index = 0

  onProgress?.(0, total)

  async function worker() {
    while (index < total) {
      const i = index++
      results[i] = await compressImage(files[i])
      done++
      onProgress?.(done, total)
    }
  }

  await Promise.all(
    Array.from({ length: Math.min(COMPRESSION_CONCURRENCY, total) }, () =>
      worker()
    )
  )

  return results
}
